<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_entity_type } from '@/services/entity_type';
import { get_entity_type_meta, get_entity_types, create_entity_type, delete_entity_type, update_entity_type } from '@/services/entity_type';
import { onMounted, ref, watch } from 'vue';
import { useMagicKeys } from '@vueuse/core'
import { delete_material, get_material, get_materials } from '@/services/materials';

const keys = useMagicKeys()
const shiftCtrlA = keys['Shift+Ctrl+A']
watch(shiftCtrlA, (v) => {
  if (v){
    trueAdmin.value = !trueAdmin.value
  }
})

const entityType = ref({
  entity: '',
  description: '',
})

const entityTypes = ref([])
const isLoading = ref(true)
const trueAdmin = ref(false)
onMounted(async()=>{
  await retrieve_action()
  await get_all_module()
  isLoading.value = false
})

async function retrieve_action(){
  let response = await get_entity_types()
  if(response.error){
    swalError(response.result, true)
    return
  }
  entityTypes.value = response.result.data.data
}

async function addAction(){
  let response = await create_entity_type(entityType.value)
  if(response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('New action has been added')
  entityTypes.value.push(response.result.data.data)
}

async function deleteAction(id){
  let response = await delete_entity_type(id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Action has been deleted')
  let actionInd = entityTypes.value.findIndex(item => item.id == id)
  entityTypes.value.splice(actionInd, 1)
}

const currentEdit = ref('')
async function editEntity(entityObj){
  let response = await get_entity_type_meta(entityObj.id)
  if (response.error){
    swalError(response.result, true)
    return
  }
  currentEdit.value = entityObj
  parse_meta_key(response.result)
}

function parse_meta_key(result){
  if (result.data.included){
    const keys = result.data.included.map(item => item.attributes.key);
    currentEdit.value.notification_key = keys
  }
}

async function updateEntity(){
  let params = {
    ...currentEdit.value.attributes
  }
  let response = await update_entity_type(currentEdit.value.id, params)
  if (response.error){
    swalError(response.result, true)
    return
  }
  swalSuccess('Entity has been updated')
  currentEdit.value = ''
}

const filter = ref({
  val: 9
})

async function deleteModules(id){
  let response = await delete_material(id)
  if (response.error){
    return swalError(response.result.error)
  }
  swalSuccess('Deleted')
}
const materials = ref([])
async function get_all_module(){
  let response = await get_materials('modules')
  if (response.error){
    return swalError(response.result.error)
  }
  materials.value = response.result.data.data
}
</script>

<template>
  <div class="container-fluid">
    <Breadcrumbs main="Notification Setting"/>
    <!-- Form -->
    <div class="card"
      :class="trueAdmin ? '' : 'd-none'"
    >
      <form class="card-body" @submit.prevent="addAction()">
        <div class="d-flex align-items-center">
          <div class="row g-3 align-items-center">
            <div class="col-auto">
              <label for="entity" class="pb-0 col-form-label">
                Entity Slug
              </label>
              <p class="mt-0 form-text">
                Use in for system to detect which notification
              </p>
            </div>
            <div class="col-auto">
              <input type="text" 
                id="entity" class="form-control"
                placeholder="Entity"
                v-model="entityType.entity"
              >
            </div>
          </div>
        </div>
        <div class="mt-2 row align-items-center">
          <div class="col-auto">
            <label for="description" class="pb-0 col-form-label">
              Description
            </label>
            <p class="mt-0 form-text">
              Use to display to the user
            </p>
          </div>
          <div class="col-8">
            <input type="text" 
              id="description" class="form-control"
              placeholder="Description"
              v-model="entityType.description"
            >
          </div>
          
        </div>
        <div class="mt-2 d-flex justify-content-end">
          <button class="btn btn-light-success" type="submit">
            Add Entity
          </button>
        </div>
      </form>
      
      <div v-for="mat in materials">
        <p>{{ mat.id }}</p>
        <button class="btn btn-light-danger" @click="deleteModules(mat.id)">
          x
        </button>
      </div>
    </div>
    <!-- Filter -->
    <div class="d-flex mb-4">
      <button class="me-2 btn rounded-pill btn-light-primary"
        :class="filter.val == 9 ? 'active' : ''"
        @click="filter.val = 9"
      >
        All
      </button>
      <button class="me-2 btn rounded-pill btn-light-primary"
        :class="filter.val == 1 ? 'active' : ''"
        @click="filter.val = 1"
      >
        Admin
      </button>
      <button class="me-2 btn rounded-pill btn-light-primary"
        :class="filter.val == 0 ? 'active' : ''"
        @click="filter.val = 0"
      >
        User
      </button>
    </div>
    <div class="card">
      <loadingCard v-if="isLoading" />
      <div class="card-body" v-else>
        <EmptyCard v-if="entityTypes.length == 0" />
        <template v-else>
          <template v-for="entity in entityTypes" :key="entity.id">
            <div v-if="filter.val == entity.attributes.level" class="mb-2 card border shadow-none">
              <template v-if="currentEdit.id != entity.id">
                <div class="card-body d-flex justify-content-between align-items-center">
                  <div class="col-md-6">
                    <p class="mb-0">
                      <b>Entity Slug : </b>
                      {{ entity.attributes.entity }}
                    </p>
                    <p class="text-secondary">
                      <b>Description : </b>
                      {{ entity.attributes.description }}
                    </p>
                  </div>
                  
                  <div class="col-md-2 d-flex">
                    <button class="disabled btn btn-light-primary btn-icon me-2">
                      <vue-feather type="chevron-right" size="1rem" />
                    </button>
                    <button class="btn btn-light-warning btn-icon me-2" @click="editEntity(entity)">
                      <vue-feather type="edit-2" size="1rem" />
                    </button>
                    <button class="btn btn-light-danger btn-icon" @click="deleteAction(entity.id)">
                      <vue-feather type="trash" size="1rem" />
                    </button>
                  </div>
                </div>
              </template>
              <template v-if="currentEdit.id == entity.id">
                <form class="card-body" @submit.prevent="updateEntity()">
                  <!-- Entity -->
                  <div class="d-flex align-items-center">
                    <div class="row g-3 align-items-center">
                      <div class="col-auto">
                        <label for="entity" class="pb-0 col-form-label">
                          Entity Slug
                        </label>
                        <p class="mt-0 form-text">
                          Use in for system to detect which notification
                        </p>
                      </div>
                      <div class="col-auto">
                        <input type="text" 
                          id="entity" class="form-control"
                          placeholder="Entity"
                          v-model="currentEdit.attributes.entity"
                          :disabled="trueAdmin ? false : true"
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Level -->
                  <div class="row g-3 align-items-center"
                    :class="trueAdmin ? '':'d-none'"
                  >
                    <div class="col-auto">
                      <label for="entity" class="pb-0 col-form-label">
                        Level
                      </label>
                      <p class="mt-0 form-text">
                        Level of notification/entity type
                      </p>
                    </div>
                    <div class="col-auto">
                      <input type="number" 
                        id="entity" class="form-control"
                        placeholder="Level"
                        v-model="currentEdit.attributes.level"
                      >
                    </div>
                  </div>
                  <!-- Description -->
                  <div class="mt-4 row align-items-top">
                    <div class="col-auto">
                      <label for="description" class="pb-0 col-form-label">
                        Description
                      </label>
                      <p class="mt-0 form-text">
                        Use to display to the user
                        <br>
                        $account_name will be replace as 'Your' on customer side
                      </p>
                    </div>
                    <div class="col-8">
                      <input type="text" 
                        id="description" class="form-control"
                        placeholder="Description"
                        v-model="currentEdit.attributes.description"
                      >
                      <div class="d-flex">
                        <p class="input_meta">
                          $account_name
                        </p>
                        <p v-for="key in currentEdit.notification_key" class="input_meta">
                          ${{ key }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 d-flex justify-content-end">
                    <button class="btn btn-light-success" type="submit">
                      Update Entity
                    </button>
                  </div>
                </form>
              </template>
            </div>
            <div v-if="filter.val == 9" class="mb-2 card border shadow-none">
              <template v-if="currentEdit.id != entity.id">
                <div class="card-body d-flex justify-content-between align-items-center">
                  <div class="col-md-6">
                    <p class="mb-0">
                      <b>Entity Slug : </b>
                      {{ entity.attributes.entity }}
                    </p>
                    <p class="text-secondary">
                      <b>Description : </b>
                      {{ entity.attributes.description }}
                    </p>
                  </div>
                  
                  <div class="col-md-2 d-flex">
                    <button class="disabled btn btn-light-primary btn-icon me-2">
                      <vue-feather type="chevron-right" size="1rem" />
                    </button>
                    <button class="btn btn-light-warning btn-icon me-2" @click="editEntity(entity)">
                      <vue-feather type="edit-2" size="1rem" />
                    </button>
                    <button class="btn btn-light-danger btn-icon" @click="deleteAction(entity.id)">
                      <vue-feather type="trash" size="1rem" />
                    </button>
                  </div>
                </div>
              </template>
              <template v-if="currentEdit.id == entity.id">
                <form class="card-body" @submit.prevent="updateEntity()">
                  <!-- Entity -->
                  <div class="d-flex align-items-center">
                    <div class="row g-3 align-items-center">
                      <div class="col-auto">
                        <label for="entity" class="pb-0 col-form-label">
                          Entity Slug
                        </label>
                        <p class="mt-0 form-text">
                          Use in for system to detect which notification
                        </p>
                      </div>
                      <div class="col-auto">
                        <input type="text" 
                          id="entity" class="form-control"
                          placeholder="Entity"
                          v-model="currentEdit.attributes.entity"
                          :disabled="trueAdmin ? false : true"
                        >
                      </div>
                    </div>
                  </div>
                  <!-- Level -->
                  <div class="row g-3 align-items-center"
                    :class="trueAdmin ? '':'d-none'"
                  >
                    <div class="col-auto">
                      <label for="entity" class="pb-0 col-form-label">
                        Level
                      </label>
                      <p class="mt-0 form-text">
                        Level of notification/entity type
                      </p>
                    </div>
                    <div class="col-auto">
                      <input type="number" 
                        id="entity" class="form-control"
                        placeholder="Level"
                        v-model="currentEdit.attributes.level"
                      >
                    </div>
                  </div>
                  <!-- Description -->
                  <div class="mt-4 row align-items-top">
                    <div class="col-auto">
                      <label for="description" class="pb-0 col-form-label">
                        Description
                      </label>
                      <p class="mt-0 form-text">
                        Use to display to the user
                        <br>
                        $account_name will be replace as 'Your' on customer side
                      </p>
                    </div>
                    <div class="col-8">
                      <input type="text" 
                        id="description" class="form-control"
                        placeholder="Description"
                        v-model="currentEdit.attributes.description"
                      >
                      <div class="d-flex">
                        <p class="input_meta">
                          $account_name
                        </p>
                        <p v-for="key in currentEdit.notification_key" class="input_meta">
                          ${{ key }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="mt-2 d-flex justify-content-end">
                    <button class="btn btn-light-success" type="submit">
                      Update Entity
                    </button>
                  </div>
                </form>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>